module.exports = __webpack_public_path__ + "img/left2.562e17d5.png";